var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.loginLayoutClasses },
    [
      _c("router-view", { staticClass: "loginView" }),
      _vm._v(" "),
      _c("Footer", { staticClass: "loginFooter" }),
      _vm._v(" "),
      _c("VStyle", [
        _vm._v(
          '\n\t\t.loginLayout.wallpaper\n\t\t{\n\t\tbackground-image: url("' +
            _vm._s(_vm.wallpaperUrl) +
            '");\n\t\t}\n\t'
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }